import config from '../config';
import { authHeader } from '../helpers';

const handleResponse = (response) => {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
};

const login = async () => {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
  };

  const response = await fetch(
    `${config.atsApiUrl}/event/google`,
    requestOptions
  );

  return handleResponse(response);
};

const redirect = async (authCode) => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(authCode)
  };

  const response = await fetch(
    `${config.atsApiUrl}/event/google/redirect`,
    requestOptions
  );

  return handleResponse(response);
}

const createEvent = async (formData) => {
  const requestOptions = {
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(formData),
  };

  const response = await fetch(`${config.atsApiUrl}/event/schedule_event`, requestOptions);

  return handleResponse(response);
}

const getEvent = async (eventId) => {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
  };

  const response = await fetch(
    `${config.atsApiUrl}/event/get_event/${eventId}`,
    requestOptions
  );

  return handleResponse(response);
}

const getAllEvent = async (candidateId) => {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
  };

  const response = await fetch(
    `${config.atsApiUrl}/event/getallevents/${candidateId}`,
    requestOptions
  );

  return handleResponse(response);
}

const updateEvent = async (eventId, formData) => {
  const requestOptions = {
    method: "PATCH",
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(formData),
  };

  const response = await fetch(`${config.atsApiUrl}/event/update_event/${eventId}`, requestOptions);

  return handleResponse(response);
}

const deleteEvent = async (eventId) => {
  const requestOptions = {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
  };

  const response = await fetch(
    `${config.atsApiUrl}/event/delete_event/${eventId}`,
    requestOptions
  );

  return handleResponse(response);
}

const logout = async () => {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
  };

  const response = await fetch(
    `${config.atsApiUrl}/event/logout`,
    requestOptions
  );

  return handleResponse(response);
};



export const googleCalendarService = {
  login,
  redirect,
  getEvent,
  getAllEvent,
  createEvent,
  updateEvent,
  deleteEvent,
  logout
}